export default {
    currentTimestamp: (new Date()).getTime()
}
